module.exports = __webpack_public_path__ + "header_two.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/landing/header_two.jpg
// module id = 1730
// module chunks = 11